import { ChangeDetectionStrategy, Component, computed, input } from "@angular/core";

import { L2vpnSubscriptionDetails } from "../../../../../pages/subscription-detail/types";
import { InterconnectSummary } from "../../../interconnect-summary/interconnect-summary";

type L2vpnFirewallInterconnect = L2vpnSubscriptionDetails["firewallInterconnects"][number];

@Component({
  selector: "l2vpn-firewall-interconnect-panel",
  templateUrl: "l2vpn-firewall-interconnect-panel.html",
  host: { style: "display: contents" },
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [InterconnectSummary],
})
export class L2vpnFirewallInterconnectPanel {
  interconnect = input.required<L2vpnFirewallInterconnect>();

  protected service = computed(() => ({
    ...this.interconnect(),
    subscriptionId: this.interconnect().firewallSubscriptionId ?? "",
    product: { type: "FW", tag: "FW" },
  }));
}
